/** @format */

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type PriceModifier = {
    id: string;
    modelId: number;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    present: boolean;
    value: number;
    declineReason: DeclineReason | null;
};

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum DeclineReason {
    NOT_RECEIVED = 'not-received',
    ACCESSORY_BROKEN = 'accessory-broken',
    POOR_RECHARGE = 'poor-recharge',
    NOT_PURCHASED = 'not-purchased',
}
